import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48b38f72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "create-name"
}
const _hoisted_2 = { class: "nav-content_config" }
const _hoisted_3 = { class: "nav-content_config_row" }


const __default__ = {
  name: 'EntryNewNav'
}

import { h, ref, reactive, computed } from 'vue'
import { MessageRenderMessage, NDropdown, NSpace, useMessage } from 'naive-ui'
import type { MessageReactive } from 'naive-ui'
import Icon from '@teams/common/components/icon'
import { useI18n } from 'vue-i18n'
import CreateConfig from './createConfig.vue'
import { useAppDialog } from '@/components/appDialog'
import SelectFileInsideGroup from './selectFileInsideGroup.vue'
import SelectFolderInsideGroup from './selectFolderInsideGroup.vue'
import SelectFileOutsideGroup from './selectFileOutsideGroup.vue'
import { createFileByDocerSDK } from '@teams/common/utils/createFile'
import { DocerNewFileType } from '@teams/common/utils/types'
import {
  baseFileViewOptions,
  DEFAULT_ICON_MAP,
  importFileViewOptions,
  IViewOption,
  moreViewOptions
} from '@teams/common/hooks/useAddOrUpdateNav'
import { useGroupStore } from '@/store/group'
import { EnumNavKind } from '@teams/common/api/types'
import CreateFileName from './createFileName.vue'

type Finder = {
  ftype: string
  cid?: number
  gid?: number
  tid: number
  fid: number
  name: string
}
type SelectFolderResp = {
  type: 'folder'
  finder: Finder
}
type ConfirmData = {
  navType: EnumNavKind
  nameParams?: {
    autoUpdate: boolean
    icon: string
    name: string
  }
  finder: Finder
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    hideNameInput: { type: Boolean },
    removeMarginLeft: { type: Boolean }
  },
  emits: ["updateName", "updateType"],
  setup(__props: any, { emit: emits }: { emit: ({
  (
    e: 'updateName',
    data: { autoUpdate: boolean; icon?: string; name?: string }
  ): void
  (e: 'updateType', data: ConfirmData): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  hideNameInput?: boolean
  removeMarginLeft?: boolean
}

_useCssVars(_ctx => ({
  "0af178f6": (_unref(multipleStyle).marginLeft)
}))




const dialog = useAppDialog()
const message = useMessage()
const groupStore = useGroupStore()
const { t } = useI18n()
// eslint-disable-next-line
const $tt = (key: string, ...params: any[]) => {
  // @ts-ignore
  return t(`components.navigator.addOrUpdateNav.${key}`, ...params)
}

const nameForm = reactive({
  autoUpdate: true,
  icon: DEFAULT_ICON_MAP[EnumNavKind.blank],
  name: '未命名标签页'
})
const nameOption = computed(() => {
  return {
    autoUpdate: nameForm.autoUpdate,
    icon: nameForm.icon,
    name: nameForm.name,
    defaultIcon: DEFAULT_ICON_MAP[EnumNavKind.blank],
    defaultName: '未命名标签页'
  }
})

const multipleStyle = computed(() => ({
  marginLeft: props.removeMarginLeft ? '0px' : '-16px'
}))

// 下拉框选择新建
const moreItem = {
  name: '新建其他',
  icon: 'moreBorder'
}
const dropDownItem = ref<IViewOption[]>()
const baseFile: IViewOption[] = Object.assign([], baseFileViewOptions)
const baseFileTypeList = baseFile.splice(0, 3)
const renderIcon = (icon: string) => {
  return () => {
    return h(Icon, {
      name: icon,
      size: 16
    })
  }
}
dropDownItem.value = baseFile
const changeFileOptions = dropDownItem.value.map(item => {
  return {
    label: item.name,
    kind: item.kind,
    key: item.key,
    icon: renderIcon(item.icon || '')
  }
})

const updateName = params => {
  const { autoUpdate, icon, name } = params
  const data = {
    autoUpdate,
    icon,
    name
  }
  Object.keys(data).forEach(key => {
    if (data[key] === undefined) {
      delete data[key]
    }
  })
  Object.assign(nameForm, data)
  emits('updateName', nameForm)
}

// 向父组件发送选择的标签类型、文件(夹)提交信息
const submit = (
  navType: EnumNavKind,
  params: {
    finder: Finder
    isNewFile?: boolean
  }
) => {
  const data: ConfirmData = { navType, ...params }
  emits('updateType', data)
}
// 新建成功toast提示
let messageReactive: MessageReactive | null = null
const removeMessage = () => {
  if (messageReactive) {
    messageReactive.destroy()
    messageReactive = null
  }
}
const showCreateSuccessMsg = newFile => {
  const renderMessage: MessageRenderMessage = () => {
    return h(
      'div',
      {
        class: 'nav-message'
      },
      [
        h('div', {
          class: 'nav-message_normal',
          innerHTML: '文档将自动保存在“文档库”'
        }),
        h('div', {
          class: 'nav-message_click',
          innerHTML: '更改',
          onclick: () => {
            removeMessage()
            selectFolderInsideGroup(async params => {
              const { finder } = params
              await newFile.moveTo({
                targetGroupId: finder.tid,
                targetParentId: finder.fid
              })
              message.success('移动成功')
            })
          }
        })
      ]
    )
  }
  if (!messageReactive) {
    messageReactive = message.success('', {
      render: renderMessage,
      showIcon: false,
      keepAliveOnHover: true,
      duration: 2000
    })
  }
}
// 选择单文件新建
const selectFileCommand = (key: string | DocerNewFileType) => {
  if (Object.values(DocerNewFileType).includes(key as DocerNewFileType)) {
    createFile(key as DocerNewFileType)
  } else {
    console.log('不支持新建的文件', key)
  }
}
// 选择团队内文档
const selectFileInsideGroup = () => {
  dialog.show({
    title: $tt('selectTeamFile'),
    component: SelectFileInsideGroup,
    componentEvents: {
      confirm: context => {
        submit(EnumNavKind.file, { finder: context.finder })
      }
    },
    footer: false
  })
}

// 打开目录弹窗，选择团队内文件夹
const selectFolderInsideGroup = (
  callBack: (params: SelectFolderResp) => void
) => {
  dialog.show({
    title: $tt('selectFolder'),
    component: SelectFolderInsideGroup,
    componentEvents: {
      confirm: (context: SelectFolderResp) => {
        callBack(context)
      }
    },
    footer: false
  })
}
// 基于目录弹窗提供不同参数完成更新视图
const selectFolder = (navType: EnumNavKind) => {
  selectFolderInsideGroup(params => {
    submit(navType, {
      finder: params.finder
    })
  })
}

// 导入团队外文档
const importFileIntoGroup = () => {
  dialog.show({
    title: $tt('importFileOutsideTeam'),
    component: SelectFileOutsideGroup,
    componentEvents: {
      confirm: context => {
        console.log('选择团队外文档', context)
        submit(EnumNavKind.file, { finder: context.finder })
      }
    },
    footer: false
  })
}

const selectFileOrViewType = (key: string) => {
  switch (key) {
    case 'selectFileInsideGroup':
      selectFileInsideGroup()
      break
    case 'importFileIntoGroup':
      importFileIntoGroup()
      break
    // 文件管理器
    case 'fileManager':
      selectFolder(EnumNavKind.folder)
      break
    // 知识库
    case 'knowledgeManager':
      selectFolder(EnumNavKind.knowledgeBase)
      break
    // 最近更新
    case 'updateManager':
      selectFolder(EnumNavKind.updates)
      break
  }
}

// 创建文件
const createFile = async (type: DocerNewFileType) => {
  const params = {
    type,
    gid: groupStore.groupId,
    pid: 0
  }
  const file = await createFileByDocerSDK(params)
  // 获取文件信息
  const { fileinfo } = await file.getFileMetadata()
  // 成功msg
  showCreateSuccessMsg(file)
  submit(EnumNavKind.file, {
    finder: {
      ftype: 'file',
      name: fileinfo.fname,
      fid: fileinfo.fileid,
      tid: fileinfo.groupid
    },
    isNewFile: true
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nav-content", !props.hideNameInput ? 'nav-content_padding' : ''])
  }, [
    (!props.hideNameInput)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(CreateFileName, {
            nameOption: _unref(nameOption),
            onUpdate: updateName
          }, null, 8, ["nameOption"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: _normalizeClass(["nav-content_config_title", 
              !props.hideNameInput ? 'nav-content_config_title_margin' : ''
            ])
          }, " 将文档作为标签页 ", 2),
          _createVNode(_unref(NSpace), {
            vertical: "",
            size: 8
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(baseFileTypeList), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "config-item__file"
                }, [
                  _createVNode(CreateConfig, {
                    item: item,
                    onClick: ($event: any) => (createFile(item.key))
                  }, null, 8, ["item", "onClick"])
                ]))
              }), 128)),
              _createVNode(_unref(NDropdown), {
                trigger: "click",
                options: _unref(changeFileOptions),
                onSelect: selectFileCommand,
                placement: "bottom-start",
                class: "create-file__dropdown"
              }, {
                default: _withCtx(() => [
                  _createVNode(CreateConfig, {
                    item: moreItem,
                    class: "config-item__more"
                  })
                ]),
                _: 1
              }, 8, ["options"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(importFileViewOptions), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "nav-content_config_have config-item__file",
                  key: index
                }, [
                  _createVNode(CreateConfig, {
                    item: item,
                    onClick: ($event: any) => (selectFileOrViewType(item.key))
                  }, null, 8, ["item", "onClick"])
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: _normalizeClass(["nav-content_config_title", 
              !props.hideNameInput ? 'nav-content_config_title_margin' : ''
            ])
          }, " 更多标签页 ", 2),
          _createVNode(_unref(NSpace), {
            vertical: "",
            size: 16
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(moreViewOptions), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "config-item__view"
                }, [
                  _createVNode(CreateConfig, {
                    item: item,
                    onClick: ($event: any) => (selectFileOrViewType(item.key)),
                    size: 24
                  }, null, 8, ["item", "onClick"])
                ]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 2))
}
}

})